import { initNav } from '../nav.ts';
import { initCartBadge } from '../cart/cartBadge.ts';
import { initAddToCartButtons } from '../cart/cartActions.ts';
import { initCartSidebar } from '../cart/cartSidebar.ts';
import { initWishlistPopup } from '../wishlist/wishlistPopup.ts';
import { initWishlistButtons, initWishlistBadge } from '../wishlist/wishlistActions.ts';

initNav();
initCartBadge();
initAddToCartButtons();
initCartSidebar();

const { open: openWishlistPopup } = initWishlistPopup();
initWishlistButtons(openWishlistPopup);
initWishlistBadge();
